const CustomGradingSection = () => {
  return (
    <section className="relative py-16 sm:py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-2 lg:gap-8">
          <div className="flex flex-col justify-center">
            <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
              Custom Grading Scales
            </h2>
            <p className="mt-4 text-lg text-gray-600">
              Tailor your transcript to match any grading system. Our flexible custom grading scales
              feature allows you to:
            </p>
            <ul className="mt-8 space-y-4 text-gray-600">
              <li className="flex items-start">
                <span className="mr-2">•</span>
                Create personalized grading scales that match your institution's requirements
              </li>
              <li className="flex items-start">
                <span className="mr-2">•</span>
                Convert between different grading systems effortlessly
              </li>
              <li className="flex items-start">
                <span className="mr-2">•</span>
                Support international grading standards and conversions
              </li>
              <li className="flex items-start">
                <span className="mr-2">•</span>
                Maintain consistency across all your transcripts
              </li>
            </ul>
          </div>
          <div className="flex items-center justify-center">
            <img
              src="/custom-grading-scale-feature.png"
              alt="Custom Grading Scale Feature"
              className="rounded-lg shadow-xl max-w-full h-auto"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default CustomGradingSection;
